/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcCorpactionsCaadminV1ActionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_CORPACTIONS_CAADMIN_V1_ACTION_STATE_ENTITY_NAME = 'ixc.corpactions.caadmin.v1.Action';
export const ixcCorpactionsCaadminV1ActionStateEntity = new schema.Entity<IxcCorpactionsCaadminV1ActionState>(IXC_CORPACTIONS_CAADMIN_V1_ACTION_STATE_ENTITY_NAME, {}, { idAttribute: 'actionId' });

